import { get } from '../lib/http';
import { GetServerSidePropsContext } from 'next';
import { HttpPrefix } from '../lib/wemeet-http-moudle';

interface ChangeAccoutRes {
  code: number;
  message: string;
  nonce: string;
  data: {
    is_can_change_account: boolean;
  };
}

// 退出登录
const getChangeAccout = async (ctx?: GetServerSidePropsContext) => {
  try {
    const response = await get<ChangeAccoutRes>(
      HttpPrefix.WEMEET_WEB_API,
      '/v2/account/profile/change-account',
      {},
      ctx,
    );
    return response;
  } catch (e) {
    console.error('request error', e);
  }
  return null;
};
export default getChangeAccout;
